import { Button } from '@base-ui/react';
import styled from '@emotion/styled';

import { focusRing } from '../../interaction-states';
import { spacing } from '../../spacing';

export const StyledOptionCard = styled(Button)(({ theme }) => ({
  ...focusRing(theme),
  display: 'flex',
  alignItems: 'center',
  gap: spacing[12],
  width: '100%',
  boxSizing: 'border-box',
  padding: `${spacing[12]}px 0`,
  textAlign: 'left',
  background: 'none',
  border: 'none',
  borderRadius: theme.radius[8],
  color: theme.colors.text.primary,
  cursor: 'pointer',
}));

export const IconBox = styled('div')(({ theme }) => ({
  width: 52,
  height: 52,
  minWidth: 52,
  borderRadius: theme.radius[8],
  backgroundColor: theme.colors.white[8],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,

  svg: {
    width: 24,
    height: 24,
    color: theme.colors.icon.primary,
  },

  'svg, svg *': {
    strokeWidth: 1.5,
  },
}));

export const TextBlock = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing[6],
  flex: 1,
  minWidth: 0,
});

export const TitleRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: spacing[6],
});

export const ArrowBox = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  flexShrink: 0,
  padding: 10,
  borderRadius: theme.radius[8],
  backgroundColor: 'transparent',
  color: theme.colors.white[100],
  border: `1px solid ${theme.colors.white[20]}`,
  boxShadow: [
    `0px 1px 2px -1px ${theme.colors.black[10]}`,
    `0px 1px 3px 0px ${theme.colors.black[10]}`,
  ].join(', '),

  svg: {
    width: 20,
    height: 20,
  },
}));
